<template>
	<div class="global-header-container">
		<!-- <a v-if="isHome"> -->
			<div class="point-check">
				<div>{{headerCheck}}</div>
				<div class="language-block">
					<el-dropdown trigger="click" @command="handleCommand">
						<div class="language-inner">
							<img src="../assets/images/language.png" class="language-icon"/>
							<span>{{$t('common.language')}}</span>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="zh">简体中文<img src="../assets/images/checkmark.svg" v-if="lang == 'zh'" class="language-check-iocn"/></el-dropdown-item>
							<el-dropdown-item command="en">English<img src="../assets/images/checkmark.svg" v-if="lang == 'en'" class="language-check-iocn"/></el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
		<!-- </a> -->
		<template v-if="!isMobile">
			<div class="full-width-header css-grid-container">
				<div class="header-logo-container css-grid-span-4">
					<a href="javascript:void()" @click="openPage('/')" class="header-logo-link">
						<img class="header-logo-img" src="@/assets/images/slogo.png">
					</a>
				</div>
				<div class="header-contact-info-container css-grid-span-5">
					<div class="primary-contact-info">
						<a :href="'tel:+1-'+mobile" class="contact-no">
							<div>{{mobile}}</div>
						</a>
					</div>
					<div class="secondary-contact-info">
						<a class="secondary-contact-info-label" href="javascript:void(0)">
							<div>{{headerTitle}}</div>
						</a>
					</div>
				</div>
				<div class="header-search-container css-grid-span-10">
					<div class="comp-search-lookahead-container">
						<div class="comp-search-bar-container active">
							<input v-model="searchName" class="search-bar-input" type="text" :placeholder="$t('tips.inputsearch')" maxlength="200"
								autocomplete="off" @keyup.enter="searchProduct"/>
							<button class="search-bar-btn" @click="searchProduct">
								<img src="../assets/images/search.png" class="dri-search" />
							</button>
							<!-- <div class="search-bar-loader">
								<span class="search-bar-loader-icon fa fa-spinner fa-spin"></span>
							</div> -->
						</div>
					</div>
				</div>
				<div class="header-account-info-container css-grid-span-5">
					<div class="account-dropdown js-account-dropdown-container">
						<div class="account-wrapper">
							<div class="account-salutation customer-loaded">
								<span>{{$t('common.hi')}}</span>
								<span class="customer-name" v-if="!isLogin">
									<span class="js-customer-name">{{$t('common.login')}}</span>
								</span>
								<span class="customer-name" v-else>
									<span class="js-customer-name">{{nickName}}！</span>
								</span>
							</div>
							<div @click="openPage('/user')" class="account-link-dropdown dropdown-toggle" >
								<span>{{$t('common.youraccount')}}</span>
							</div>
							<!-- <button onfocus="hideExpandButton()" onblur="hideExpandButton()" class="nav-expander"
								onclick="showAccountDropdown ? showAccountDropdown() : ''">
								展开：您的帐户
							</button> -->
						</div>
						<div class="account-dropdown-menu-wrapper">
							<ul class="account-dropdown-menu dropdown-menu">
								<template v-if="showLogin && !isLogin">
									<li class="login-button-wrapper js-loaded-customer">
										<button @click="openLoginMadal" class="login-button btn btn-primary site-btn-primary">
											{{$t('common.login2')}}
										</button>
									</li>
									<li class="js-loaded-customer">
										<a href="javascript:void(0)" @click="changeRegister" class="account-register-link js-account-register-link">
											<span class="new-customer-text">{{$t('common.newcustomer')}}</span>
											<span class="create-account-text">{{$t('common.createaccount')}}</span>
										</a>
									</li>
								</template>
								
								<li @click="openPage('order')">
									<a href="javascript:void(0)" >{{$t('common.myorder')}}</a>
								</li>
								<li @click="openPage('user')">
									<a href="javascript:void(0)" >{{$t('common.accountdetail')}}</a>
								</li>
								<li @click="openPage('address')">
									<a href="javascript:void(0)">{{$t('common.address')}}</a>
								</li>
								<li @click="openPage('paymethod')">
									<a href="javascript:void(0)">{{$t('common.paymentmethod')}}</a>
								</li>
								<li class="js-customer-logout" v-if="isLogin">
									<a class="logout-link" href="javascript:void(0)" @click="dologout">{{$t('common.logout')}}</a>
								</li>
							</ul>
						</div>
					</div>
					<div class="js-cart-count cart-count-wrapper">
						<div class="js-cart-container cart-icon-wrapper " :class="cartNum > 0 ? 'has-item' : ''">
							<div class="js-show-as-not-link " :class="cartNum == 0 ? 'show' : 'hide'">
								<span class="cart-img-count-wrapper js-cart-dropdown-link" @click="openPage('/cart')">
									<i class="js-cart-icon cart-icon"></i>
									<i class="js-cart-icon-with-item cart-icon-with-item"></i>
									<span class="cart-count js-total-cart-count js-total-exceed-count"></span>
									<span class="cart-label">{{$t('common.cart')}}</span>
								</span>
								<div class="js-show-cart-count-dropdown">
									<ul class="dropdown-menu cart-dropdown-menu pull-right">
										<li>
											<a class="cart-link js-cart-link-po"></a>
										</li>
										<li>
											<a class="cart-link js-cart-link-ffr"></a>
										</li>
									</ul>
								</div>
							</div>
							<div class="js-show-as-link" :class="cartNum > 0 ? 'show' : 'hide'" @click="openPage('/cart')">
								<a id="po_cart_count">
									<span class="cart-img-count-wrapper">
										<i class="cart-icon js-cart-icon hide"></i>
										<i class="cart-icon-with-item js-cart-icon-with-item show"></i>
										<span class="js-po-cart-count js-po-exceed-count cart-count">{{cartNum}}</span>
										<span class="cart-label">{{$t('common.cart')}}</span>
									</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="global-header-nav-container">
				<div class="site-navbar container">
					<div class="header-nav-list-group js-menu-nav ga4-nav-click header">
						<div class="js-nav-link-list nav-link-list hover-lazy" v-for="(item,index) in categoryList" :key="index" @click="openPage('/category?no='+item.pid+'&level=1')">
							<div class="nav-heading-link js-nav-link-list">{{item.typeName}}</div>
						</div>
						<div class="js-nav-link-list nav-link-list hover-lazy" @click="openPage('/designService')">
							<div class="nav-heading-link js-nav-link-list">{{$t('common.designservice')}}</div>
						</div>
						<div class="js-nav-link-list nav-link-list hover-lazy" @click="openPage('/blog')">
							<div class="nav-heading-link js-nav-link-list">{{$t('common.printingknowledge')}}</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="mobile_header_container_js mobile-header-container fade-out-search">
				<div class="mobile-header-row">
					<div class="mobile-burger-wrapper" @click="openMobileMenu">
					    <i class="mobile-hamburger js-mobile-product-menu-shown-burger"></i>
					    <i class="mobile-search-icon"></i>
					</div>
					<div class="mobile-logo-wrapper">
					    <!-- <div class="mobile-need-help-wrapper"></div> -->
						<div class="mobile-language-wrapper">
							<el-dropdown trigger="click" @command="handleCommand">
								<div class="mobile-language-wrapper-icon"></div>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="zh">简体中文<img src="../assets/images/checkmark.svg" v-if="lang == 'zh'" class="language-check-iocn"/></el-dropdown-item>
									<el-dropdown-item command="en">English<img src="../assets/images/checkmark.svg" v-if="lang == 'en'" class="language-check-iocn"/></el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
					    <a href="javascript:void()" @click="openPage('/')">
					        <img class="mobile-logo" src="../assets/images/slogo.png">
					    </a>
					    <a class="mobile-account-wrapper" href="javascript:void()" @click="openPage('/user')"></a>
					</div>
					<div class="mobile-cart-wrapper js-mobile-cart-wrapper" :class="cartNum > 0 ? 'has-item' : ''">
					    <div class="cart-icon-wrapper" @click="openPage('/cart')">
					        <span class="cart-img-count-wrapper">
					            <i class="cart-icon js-cart-icon " v-if="cartNum == 0"></i>
					            <i class="cart-icon-with-item js-cart-icon-with-item show" v-if="cartNum > 0"></i>
					        </span>
					        <span class="cart-count js-total-cart-count" v-if="cartNum > 0">{{cartNum}}</span>
					        <div class="js-show-cart-count-dropdown">
					            <ul class="dropdown-menu cart-dropdown-menu pull-right">
					                <li>
					                    <a class="cart-link js-cart-link-po"></a>
					                </li>
					                <li>
					                    <a class="cart-link js-cart-link-ffr"></a>
					                </li>
					            </ul>
					        </div>
					    </div>
					</div>
					<div class="js-mobile-product-menu-shown mobile-side-nav-drawer w-100 h-100 hidden-lg hidden-md display-mobile ng-scope" :class="showMobileMenu ? 'open' : ''">
						<div class="mobile-side-nav-drawer-slider ga4-nav-click header">
							<div class="mobile-side-nav-drawer-track h-100 text-nowrap" :class="showAccountMenu ? 'open-sub-menu' : 'close-sub-menu'">
								<div class="mobile-side-nav-drawer-slide">
									<div class="d-flex flex-column h-100 align-items-start text-center">
										<div class="mobile-side-nav-drawer-header">
										    <div class="align-items-center text-left mobile-side-nav-drawer-search">             
												<div class="comp-search-lookahead-container">
													<div class="comp-search-bar-container">
														<input v-model="searchName" @keyup.enter="searchProduct" class="search-bar-input" type="text" :placeholder="$t('tips.inputsearch')" maxlength="200" autocomplete="off">
										                <button class="search-bar-btn" @click="searchProduct">
															<span class="dri-search"></span>
														</button>
										            </div>
												</div>
										    </div>
										</div>
										<div class="mobile-side-nav-drawer-list flex-fill h-100" style="min-height:1px">
											<div class="mobile-navigation-container">
												<ul class="main-mobile-navigation">
													<li class="parent-catalog-item-container" v-for="(item,index) in categoryList" :key="index">
													    <a href="javascript:void(0)" @click="openPage('/category?no='+item.pid+'&level=1')">
													        <i class="site-icon-gear mobile-only"></i>
													        <span class="menu-item">{{item.typeName}}</span>
													    </a>
													</li>
													<li class="parent-catalog-item-container">
													    <a href="javascript:void(0)" @click="openPage('/designService')">
													        <i class="site-icon-gear mobile-only"></i>
													        <span class="menu-item">{{$t('common.designservice')}}</span>
													    </a>
													</li>
													<li class="parent-catalog-item-container">
													    <a href="javascript:void(0)" @click="openPage('/blog')">
													        <i class="site-icon-gear mobile-only"></i>
													        <span class="menu-item">{{$t('common.printingknowledge')}}</span>
													    </a>
													</li>
												</ul>
												<ul class="fixed-bottom-mobile-navigation">
												    <li class="parent-catalog-item-container">
												        <a class="" href="javascript:void(0)" @click="openPage('/quotes')">
												            <i class="site-icon-custom-quote border-top mobile-only fixed-bottom"></i>
												            <span class="menu-item">{{$t('common.customquote')}}</span>
												        </a>
												    </li>
												    <li class="parent-catalog-item-container">
												        <a class="" href="javascript:void(0)" @click="openPage('/designService')">
												            <i class="site-icon-design-services design-services mobile-only fixed-bottom"></i>
												            <span class="menu-item">{{$t('common.designservice')}}</span>
												        </a>
												    </li>
												    <li class="parent-catalog-item-container" @click="openAccountMenu">
												        <a class="has-children line-break">{{$t('common.myaccount')}}<i class="right-icon"></i></a>
												    </li>
												    <li class="parent-catalog-item-container">
												        <a href="javascript:void(0)" @click="openPage('/order')">{{$t('common.myorder')}}</a>
												    </li>
												</ul>
											</div>
										</div>
										<div class="mobile-side-nav-drawer-controls js-mobile-cart-wrapper " :class="cartNum > 0 ? 'has-item' : ''">
										    <div class="d-flex flex-row align-items-middle justify-content-between">
										        <a href="javascript:void(0)" @click="openPage('/article?no=13')">
										            <i class="drawer-icon-help"></i>
										            <small>{{$t('common.needhelp')}}？</small>
										        </a>
										        <a href="javascript:void()" @click="openAccountMenu">
										            <i class="drawer-icon-account"></i>
										            <small>{{$t('common.account')}}</small>
										        </a>
										        <a href="javascript:void()" @click="openPage('/cart')">
										            <span class="cart-count js-total-cart-count">{{cartNum}}</span>
										            <i class="drawer-icon-cart"></i>
										            <small>{{$t('common.cart1')}}</small>
										        </a>
										    </div>
										</div>
									</div>
								</div>
								<div class="mobile-side-nav-drawer-slide">
									<div class="d-flex flex-column h-100 align-items-start text-center">
										<div class="mobile-side-nav-drawer-header d-flex flex-row align-items-center">
										    <a href="javascript:void()" @click="closeAccountMenu" data-slide-action="prev">
												<img src="../assets/images/left.png" class="left-icon"/>
											</a>
										    <a href="javascript:void(0)" @click="openPage('/user')" class="mobile-side-nav-drawer-link-out flex-fill no-link">
										        <span class="js-current-nav-title mobile-side-nav-drawer-title">{{$t('common.myaccount')}}</span>
										    </a>
										</div>
										<div class="mobile-side-nav-drawer-list flex-fill h-100" style="min-height:1px">
											<span class="hr"></span>
											<ul>
											    <li class="js-show-account"> 
											        <ul>
											            <li v-if="!isLogin" class="js-loaded-customer mobile-account-dropdown-list" @click="openLoginMadal()">
															<button class="login-button btn site-btn-primary">{{$t('common.loginorcreateaccount')}}</button>
											            </li>
											           <!-- <li class="parent-catalog-item-container js-customer-logout hide customer-salutation account-salutation customer-loaded">您好，<span class="js-customer-name">请登录！</span></li> -->
											            <li @click="openPage('order')" class="parent-catalog-item-container">
											                <a href="javascript:void()">{{$t('common.myorder')}}</a>
											            </li>
											            <li @click="openPage('user')" class="parent-catalog-item-container">
											                <a href="javascript:void()">{{$t('common.accountdetail')}}</a>
											            </li>
											            <li @click="openPage('address')" class="parent-catalog-item-container">
											                <a href="javascript:void()">{{$t('common.address')}}</a>
											            </li>
											            <li @click="openPage('paymethod')" class="parent-catalog-item-container">
											                <a href="javascript:void()">{{$t('common.paymentmethod')}}</a>
											            </li>
											            <li v-if="isLogin" class="parent-catalog-item-container">
											                <a href="javascript:void()" @click="dologout" class="js-customer-logout hide">{{$t('common.logout')}}</a>
											            </li>
											        </ul>
											    </li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="mobile-side-nav-drawer__backdrop w-100 h-100" @click="closeMobileMenu"></div>
					</div>
				</div>
				<div class="header-search-container mobile-search-container js-mobile-product-menu-shown-hide">
					<div class="comp-search-lookahead-container">
					    <div class="comp-search-bar-container">
					        <input class="search-bar-input" type="text" :placeholder="$t('tips.inputsearch')" maxlength="200" autocomplete="off">
					        <button class="search-bar-btn">
					            <span class="dri-search"></span>
					        </button>
					    </div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	import {initHeader,queryCartQty,logout} from '../api/api.js'
	export default {
		props: {
			isHome:{
				type: Boolean,
				default: false,
			},
			showLogin:{
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
				isMobile:false,
				showMobileMenu:false,
				showAccountMenu:false,
				cartNum:0,
				lang:'',
				headerCheck:'',
				categoryList:[],
				mobile:'',
				headerTitle:'',
				isLogin:false,
				nickName:'',
				searchName:''
			};
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
			var token = localStorage.getItem('token')
			this.isLogin = token ? true : false
			this.init()
			if(this.isLogin){
				this.nickName = localStorage.getItem('nickname') || ''
				this.queryCartQty()
			}
		},
		methods: {
			init(){
				var that = this;
				let params = {}
				initHeader(params).then(res => {
					if (res.code == 200) {
						that.headerCheck = res.data.hometitle
						that.headerTitle = res.data.title
						that.mobile = res.data.mobile
						that.categoryList = res.data.categoryFirst
					}
				})
			},
			queryCartQty(){
				var that = this;
				let params = {}
				queryCartQty(params).then(res => {
					if (res.code == 200) {
						that.cartNum = res.data.qty
					}
				})
			},
			openMobileMenu(){
				this.showMobileMenu = true
				this.showAccountMenu = false
			},
			closeMobileMenu(){
				this.showMobileMenu = false
				this.showAccountMenu = false
			},
			openAccountMenu(){
				this.showAccountMenu = true
			},
			closeAccountMenu(){
				this.showAccountMenu = false
			},
			openLoginMadal(){
				this.closeMobileMenu()
				this.$emit('openLoginMadal')
			},
			changeRegister(){
				this.$emit('changeRegister',true)
			},
			handleCommand(command) {
				this.lang = command
				this.confirmLang()
			},
			confirmLang(){
				this.$i18n.locale = this.lang
				localStorage.setItem("lang", this.lang);
				location.reload()
			},
			dologout(){
				var that = this;
				let params = {}
				logout(params).then(res => {
					if (res.code == 200) {
						localStorage.removeItem('token');
						localStorage.removeItem('email');
						localStorage.removeItem('nickname');
						that.openPage('/')
					}else{
						that.$message.warning(res.msg);
						return false;
					}
				})
			},
			searchProduct(){
				this.openPage('/search?search='+this.searchName)
			}
		}
	}
</script>

<style scoped>
	@import url('../assets/css/header.css');
	.open-sub-menu {
		transform: translateX(-100%);
	}
	.close-sub-menu {
		transform: translateX(0px);
	}
</style>
